import React from 'react';
import { NumericFormat } from 'react-number-format';

export const PercentInput = ({ field, form }) => {
  const handleValueChange = (values) => {
    const { floatValue } = values;

    // Only allow numbers between 0 and 100
    if (floatValue === undefined || floatValue <= 100) {
      form.setFieldValue(field.name, floatValue || ''); // Update Formik with the raw number
    }
  };

  return (
    <div className="tw-relative">
      <NumericFormat
        {...field}
        className="custom-input !tw-pl-8 !tw-border !tw-rounded-lg !tw-w-full !tw-h-12 !bg-white"
        value={field.value}
        onValueChange={handleValueChange}
        suffix="%"
        decimalScale={0} // No decimals allowed
        isAllowed={(values) => {
          const { floatValue } = values;
          return floatValue === undefined || floatValue <= 100; // Only allow up to 100
        }}
        allowNegative={false} // Prevent negative values
        placeholder="Enter percentage"
        onBlur={() => form.setFieldTouched(field.name, true)}
      />
    </div>
  );
};
